import { defaultConfig } from './config'

export function formatCurrency(value, currency = defaultConfig.currency) {
    const formats = {
        USD: () => {
            return `$${new Intl.NumberFormat('en-GB', {
                currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `${value} ${currency}`
}
export function showSubtitle(prod , name){
    return prod?.customFields?.map(field => {
        if(location.pathname.startsWith("/es/")) {
            if(field.key == 'global-subtitle: nosto.es_product_subtitle' || field.key == 'global-   \t subtitle: nosto.es_product_subtitle' || field.key == 'global-subtitle: nosto．es_product_subtitle') return field.value;
        } else {
            if(field.key == 'pim-subtitle') return field.value;
        }
    })
}

export function staticBundleAtc(variantId, quantity = 1) {
    if(variantId && typeof window.theme.addStaticBundleToCart === 'function') {
        window.theme.addStaticBundleToCart(variantId, quantity);
    }
}